import { Card, Col, Row } from 'antd';
import React, { useMemo } from 'react';
import CameraConfigDTO from 'src/models/CameraConfigDTO';
import PlatformSettingsDTO from 'src/models/PlatformSettingsDTO';
import { CameraImage } from './CameraImage';

export interface OneToManyBinCamerasProps {
    binId: number;
    binNumber: number;
    platformSettings: PlatformSettingsDTO | null | undefined;
}

function camerasForBin(
    platformSettings: PlatformSettingsDTO | null | undefined,
    binNumber: number,
): CameraConfigDTO[] {
    return (platformSettings?.camerasConfiguration?.cameras ?? [])
        .filter((camera) => camera.assignedBinNumbers?.includes(binNumber));
}

export const OneToManyBinCameras = (props: OneToManyBinCamerasProps) => {
    const cameras = useMemo(
        () => camerasForBin(props.platformSettings, props.binNumber),
        [props.platformSettings, props.binNumber],
    );

    if (cameras.length === 0) {
        return null;
    }

    return (
        <>
            {cameras.map((camera) => (
                <Card
                    key={camera.number}
                    title={`Bin Camera - ${camera.displayName ?? `Camera ${camera.number}`}`}
                    style={{ marginBottom: 16 }}
                >
                    <Row style={{ paddingTop: '16px' }} justify={'center'}>
                        <Col>
                            <CameraImage
                                binId={props.binId}
                                cameraNumber={camera.number}
                            />
                        </Col>
                    </Row>
                </Card>
            ))}
        </>
    );
};
